var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M160.235,276.571l-144.5-159.983c-9.383,5.578-15.734,15.711-15.734,27.414v256.005c0,17.672,14.328,31.994,32,31.994 h268.625l-58.867-65.17C196.993,360.155,162.407,322.662,160.235,276.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d1d1d1",
    d: "M480.001,112.001h-112l-23.156-46.313c-5.422-10.84-16.5-17.687-28.625-17.687H195.782 c-12.125,0-23.203,6.848-28.625,17.688l-10.836,21.672L87.782,10.594C75.985-2.539,55.735-3.61,42.594,8.211 c-13.141,11.828-14.203,32.063-2.375,45.196l399.992,448c6.313,7.024,15.031,10.594,23.797,10.594 c7.625,0,15.281-2.711,21.391-8.211c13.141-11.828,14.203-32.067,2.375-45.2l-23.734-26.59h15.961c17.672,0,32-14.321,32-31.994 V144.002C512.001,126.33,497.672,112.001,480.001,112.001z M237.196,177.94c6.086-1.219,12.359-1.938,18.805-1.938 c53.016,0,96,42.981,96,96.002c0,10.223-1.758,19.996-4.727,29.227L237.196,177.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPhoto);
export default __webpack_public_path__ + "static/media/no-photo.2bc13db9ad211d03115dea87a394aaba.svg";
export { ForwardRef as ReactComponent };